import { AxiosRequestConfig } from 'axios'

import router from '@/router'
import { logger } from '@/sdk/oauth'
import store from '@/store'

/**
 * Session Interceptor
 *
 * Adds bearer token to requests.
 * Redirects to login page if user is not logged in.
 */
export default async (
  requestConfig: AxiosRequestConfig,
): Promise<AxiosRequestConfig> => {
  logger('userRequest -> request interceptor config -> %O', requestConfig)

  if (!store.getters['auth/userToken']()) {
    store.commit('auth/deleteAuth')
    router.replace('/login')

    return Promise.reject(new Error('no user token in store'))
  }

  const newConfig = {
    ...requestConfig,
    headers: {
      ...(requestConfig.headers || {}),
      Authorization: `Bearer ${store.getters['auth/userToken']()}`,
    },
  }

  return Promise.resolve(newConfig)
}
